module.exports = __webpack_public_path__ + "img/luz.539fa625.jpg";